import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FangDropdownComponent} from './fang-dropdown.component';
import {FangChipGroupModule} from '../chip-group/fang-chip-group.module';
import {FangSearchModule} from '../search-field/fang-search.module';
import {FangDirectivesModule} from '../../directives/fang-directives.module';

@NgModule({
	imports: [
		CommonModule,
		FangChipGroupModule,
		FangSearchModule,
		FangDirectivesModule
	],
	exports: [
		FangDropdownComponent
	],
	declarations: [
		FangDropdownComponent
	],
	providers: [],
	entryComponents: [FangDropdownComponent]
})
export class FangDropdownModule {
}
